import React, { useEffect } from "react";
import { Mic, MicOff, RotateCcw } from "lucide-react";
import { useSpeechToText } from "../../hooks/useSpeechToText";

const CrmVoiceNotePanel = ({ value = "", onChange }) => {
  const speech = useSpeechToText({ lang: "en-IN", continuous: true });

  useEffect(() => {
    return () => speech.stop();
  }, [speech.stop]);

  useEffect(() => {
    if (!speech.transcript) return;
    const base = String(value || "").trim();
    const spoken = speech.transcript.trim();
    if (!spoken) return;
    if (base.endsWith(spoken) || base.includes(spoken)) return;
    onChange?.(base ? `${base}\n${spoken}` : spoken);
  }, [speech.transcript, value, onChange]);

  const handleClear = () => {
    speech.resetTranscript();
  };

  return (
    <div className="crm-voice-note">
      <div className="crm-voice-note__controls">
        <button
          type="button"
          className={`crm-voice-note__mic${speech.isListening ? " is-listening" : ""}`}
          onClick={speech.toggle}
          disabled={!speech.isSupported}
          aria-label={speech.isListening ? "Stop dictation" : "Start dictation"}
        >
          {speech.isListening ? <MicOff size={16} /> : <Mic size={16} />}
          {speech.isListening ? "Stop" : "Dictate note"}
        </button>
        {(speech.liveText || value) && (
          <button type="button" className="crm-voice-note__clear" onClick={handleClear}>
            <RotateCcw size={14} />
            Clear voice
          </button>
        )}
      </div>
      {speech.error && (
        <p className="crm-voice-note__error" role="alert">
          {speech.error}
        </p>
      )}
      {speech.isListening && speech.interimTranscript && (
        <p className="crm-voice-note__live" aria-live="polite">
          {speech.interimTranscript}
        </p>
      )}
    </div>
  );
};

export default CrmVoiceNotePanel;
